import { Component, OnInit, HostBinding, ContentChild, AfterContentInit, ElementRef } from '@angular/core';
import { DropdownItemgroupLabelComponent } from '../dropdown-itemgroup-label/dropdown-itemgroup-label.component';

/**
 * Needed to give every item a unique id
 */
let nextUniqueId = 0;

/**
 * Creates a subgroup with items in a dropdown menu. Only wrap the group items inside this component. 
 *
 * Usage:
 * ```html
 * <app-responsive-dropdown-scaffold #dropdownScaffold>
 *   <div dropdown></div>
 *   <div dropdown-content>
 *     <app-dropdown-item></app-dropdown-item>
 *     <!-- Define a group -->
 *     <app-dropdown-itemgroup>
 *       <!-- Set the label (name) of the group -->
 *       <app-dropdown-itemgroup-label>{{device.name}}</app-dropdown-itemgroup-label>
 *       <!-- Dropdown items -->
 *       <app-dropdown-item></app-dropdown-item>
 *     </app-dropdown-itemgroup>
 *   </div>
 * </app-responsive-dropdown-scaffold>
 * ```
 */
@Component({
  selector: 'app-dropdown-itemgroup',
  templateUrl: './dropdown-itemgroup.component.html',
  styleUrls: ['./dropdown-itemgroup.component.scss']
})
export class DropdownItemgroupComponent implements OnInit, AfterContentInit {
  private uniqueId = nextUniqueId++;

  @HostBinding() public id = `dropdown-itemgroup-${this.uniqueId}`;
  @HostBinding('attr.role') private role = 'group';
  @HostBinding('attr.aria-labelledby') private labelledBy = `dropdown-itemgroup-${this.uniqueId}-label`;

  @ContentChild(DropdownItemgroupLabelComponent) public label: DropdownItemgroupLabelComponent;

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterContentInit() {
    this.label.id = `dropdown-itemgroup-${this.uniqueId}-label`;
  }
}
